<template>
  <div class="columns">
    <div class="column is-12">
      <sc-tabs>
        <sc-tab-item 
          v-for="(tab, index) in tabs"
          :key="index"
          :label="tab">
        </sc-tab-item>
      </sc-tabs>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  ScTabs,
  ScTabItem,
} from '@intelipost-js/secure-components';

const { mapState } = createNamespacedHelpers(
  'integrations/integrationsAppEdit',
);

export default {
  name: 'sc-tab',
  data() {
    return {
      schemaBased: {
        steps: [],
      },
      tabs: [],
    };
  },
  computed: {
    ...mapState(['appDetails']),
  },
  created() {
    this.getAppTabs();
  },
  methods: {
    async getAppTabs() {
      this.schemaBased = JSON.parse(this.appDetails.app.schemaBased);
      const dynamicTabs = this.schemaBased.steps.map(step => step.title);

      this.tabs = [
        ...dynamicTabs,
        'Configurações de envio',
        'Contatos',
        'Credenciais na Intelipost',
      ];
    },
  },
  components: {
    ScTabs,
    ScTabItem,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-edit/components/sc-tab/ScTab.vue